import React from "react";
import { connect } from "~/redux/connect";
import { SaveButton } from "~/native-ui";
import { settingsActionCreator } from "../../actions/settingsActions";
import { getFitleredViewState } from "../../StateGetters/FilteredViewStateGetters";

const mapStateToProps = (state, { modelId }) => {
    try {
        const filteredViewState = getFitleredViewState(state, modelId);
        return {
            isOwnView: !!filteredViewState.getOwnActiveView(),
            hasChanged: filteredViewState.hasChanged,
        }
    } catch (e) {
        return {
            hasChanged: false,
            isOwnView: true,
        }
    }
}

const mapDispatchToProps = (dispatch, { modelId }) => ({
    handleSave: () => dispatch(settingsActionCreator(modelId).saveViews()),
    duplicateView: () => dispatch(settingsActionCreator(modelId).duplicateView()),
})


export const SaveFilteredViews = connect(mapStateToProps, mapDispatchToProps)(
    ({ isOwnView, trans, hasChanged, handleSave, duplicateView }) => {
        const label = isOwnView ? trans("views.save") : trans("views.saveAsOwn");

        return (
            <SaveButton
                key="save"
                disabled={!hasChanged}
                onPress={isOwnView ? handleSave : duplicateView}
                label={label}
            />
        );
    }
)